<template>
  <div class="modal-integrat d-flex flex-column gap-4">
    <form-group
      v-model="form.product_id"
      select
      id="product-select"
      label="Nome do produto"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />
    <form-group
      v-model="form.token_signature"
      id="token_signature"
      label="Assinatura do Token"
      placeholder="Digite a assinatura do token da Unifast"
      :errors="errors.token_signature"
    />
    <form-group
      label="Digite o nome da empresa"
      id="company_name"
      v-model="form.company_name"
      :errors="errors.company_name"
      placeholder="Ex: minhaempresa"
    />
    <div class="d-flex justify-content-start text-neutral-300">
      <small class="mb-5 w-100">
        Nome da empresa que aparece na URL. Para https://<span
          class="text-primary"
          >minhaempresa</span
        >.integrat.com.br digite apenas:
        <span class="text-primary">
          minhaempresa
        </span>
      </small>
    </div>

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  props: {
    product_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      ...formFields(["token_signature", "product_id", "company_name"], {
        product_id: this.product_id || "",
        ...this.integrationToEdit
      })
    };
  },
  computed: {
    isValid() {
      return (
        this.form.token_signature &&
        this.form.product_id &&
        this.form.company_name
      );
    }
  }
};
</script>
